import { render } from "./nouislider.vue?vue&type=template&id=1c913e4f"
import script from "./nouislider.vue?vue&type=script&lang=js"
export * from "./nouislider.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/compare-loans.org/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__